import { createContext } from 'react';

import {
  MyTaskExtended,
  MyTasks,
  TaskWorkflowSteps,
  TicketQueryResults,
} from '@totem/components/ticketing/ticketing';
import { ObjectReference } from '@totem/types/common';

interface MyTicketsContext {
  loading: boolean;
  action: string;
  actionExtras: string;
  onAction: (newAction: string, extras: string) => void;
  myTasks: MyTasks;
  myTasksExtended: MyTaskExtended[];
  taskWorkflow: TaskWorkflowSteps;
  onTaskStatusChange: (string, TaskStatus) => void;
  myTicketData: TicketQueryResults;
  myQueues: ObjectReference[];
}

export default createContext<MyTicketsContext>({
  loading: true,
  action: '',
  actionExtras: '',
  onAction: () => {},
  myTasks: [],
  myTasksExtended: [],
  taskWorkflow: [],
  onTaskStatusChange: () => {},
  myTicketData: null,
  myQueues: [],
});
